import React from 'react';
import { Paper, Typography } from '@mui/material';
import { Contractor } from '../../../types';

interface ContractorProjectsSectionProps {
  contractor: Contractor;
  onUpdate: () => void;
}

const ContractorProjectsSection: React.FC<ContractorProjectsSectionProps> = ({ contractor, onUpdate }) => {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Project Assignments
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Project assignments for {contractor.name} will be displayed here.
      </Typography>
    </Paper>
  );
};

export default ContractorProjectsSection;
